module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs",
    class: {
      invalid: _vm.validations.$invalid
    }
  }, [_c('span', {
    class: {
      active: _vm.activeTab === _vm.TABS.GENERAL, error: _vm.validations.generalForm.$invalid
    },
    on: {
      "click": function($event) {
        _vm.selectTab(_vm.TABS.GENERAL);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("brand.navigation.general")))]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.activeTab === _vm.TABS.BRAND_ACCESS, error: _vm.validations.accessForm.$invalid
    },
    on: {
      "click": function($event) {
        _vm.selectTab(_vm.TABS.BRAND_ACCESS);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("brand.navigation.access")) + "\n    ")]), _vm._v(" "), (_vm.estoreDisplay) ? _c('span', {
    class: {
      active: _vm.activeTab === _vm.TABS.E_STORE, error: _vm.validations.estoreForm.$invalid
    },
    on: {
      "click": function($event) {
        _vm.selectTab(_vm.TABS.E_STORE);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("brand.navigation.eStore")))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3496bc47","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/brand/components/Navbar.vue
// module id = 3116
// module chunks = 0